module.exports = __webpack_public_path__ + "static/media/notification.622b1c42.png";